import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";
import { Guide as HomeGuide } from "App/Home/Process";

const Section = styled.section`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 49px;
`;

export default function Guide() {
  return (
    <Section>
      <SectionTitle>办理指南</SectionTitle>
      <SectionSubtitle>Procedure Guide</SectionSubtitle>
      <HomeGuide />
    </Section>
  );
}
